// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_title__-dKHt {
  align-items: center;
  display: flex;
  justify-content: flex-start;
}

.styles_content__J3auL {
  align-items: center !important;
  display: flex !important;
  flex-direction: column !important;
  gap: 0.75rem !important;
  padding-top: 1rem !important;
}

.styles_periodRow__Xy5mk {
  display: flex;
  gap: 0.75rem;
  width: 100%;
}

.styles_periodField__KM7lu {
  flex: 1 1;
}

.styles_contasResultadoField__Q2WGW {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  flex: 0 0 auto;
  gap: 0.1rem;
}

.styles_contasResultadoLabel__HAc0M {
  font-size: 0.75rem;
  color: rgba(0, 0, 0, 0.6);
  white-space: nowrap;
}

.styles_field__lBgUq {
  width: 100%;
}

.styles_readonlyBlock__-004d {
  width: 100%;
}

.styles_readonlyLabel__sH4Xe {
  color: rgba(0, 0, 0, 0.6);
  display: block;
  font-size: 0.75rem;
  margin-bottom: 0.25rem;
}

.styles_readonlyValue__vV\\+aM {
  font-size: 0.875rem;
}

/* Modal Reprocessar — layout semântico */
.styles_reprocessarContent__A348D {
  display: flex !important;
  flex-direction: column !important;
  align-items: stretch !important;
  gap: 1.25rem !important;
  padding-top: 0.5rem !important;
}

.styles_reprocessarContexto__fv9lg {
  margin: 0;
  padding: 1rem 1.125rem;
  border-radius: 10px;
  background: linear-gradient(180deg, #f7f9fc 0%, #f0f3f9 100%);
  border: 1px solid #e0e6f0;
}

.styles_reprocessarContextoHeader__hKuR9 {
  margin: 0 0 0.875rem;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid #e0e6f0;
}

.styles_reprocessarEmpresa__1Q2qi {
  margin: 0 0 0.2rem;
  font-size: 1rem;
  font-weight: 600;
  color: #1b3a5f;
  line-height: 1.35;
}

.styles_reprocessarCnpj__gCqQp {
  margin: 0;
  font-size: 0.8125rem;
  font-variant-numeric: tabular-nums;
  color: rgba(27, 58, 95, 0.72);
  letter-spacing: 0.01em;
}

.styles_reprocessarMeta__TobeC {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.75rem 1.25rem;
  margin: 0;
}

.styles_reprocessarMetaItem__NCWsv {
  min-width: 0;
}

.styles_reprocessarMetaItem__NCWsv dt {
  margin: 0 0 0.2rem;
  font-size: 0.6875rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: rgba(0, 0, 0, 0.45);
}

.styles_reprocessarMetaItem__NCWsv dd {
  margin: 0;
  font-size: 0.875rem;
  color: rgba(0, 0, 0, 0.87);
  word-break: break-word;
}

.styles_reprocessarSecao__d9b7o {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.styles_reprocessarSecaoTitulo__coskN {
  margin: 0;
  font-size: 0.8125rem;
  font-weight: 600;
  color: #1b3a5f;
  letter-spacing: 0.01em;
}

.styles_reprocessarFieldset__TuAPp {
  margin: 0;
  padding: 0;
  border: none;
  min-width: 0;
}

.styles_reprocessarAnosGrid__4kBjr {
  display: flex;
  flex-wrap: wrap;
  gap: 0.15rem 0.25rem;
}

.styles_reprocessarAnoItem__v1fXV {
  margin: 0 !important;
  min-width: 5.5rem;
}

.styles_reprocessarVazio__iXBWB {
  margin: 0;
  font-size: 0.875rem;
  color: rgba(0, 0, 0, 0.55);
}

.styles_reprocessarSwitch__dikVO {
  margin: 0 !important;
  align-self: flex-start;
}

.styles_srOnly__3ZNgQ {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.styles_containerBtn__DNbY0 {
  display: flex !important;
  justify-content: space-between !important;
  width: 100% !important;
  padding-left: 1.5rem !important;
  padding-right: 1.5rem !important;
  padding-bottom: 1.5rem !important;
  margin: 0 !important;
}

.styles_btnCancelar__HU2XB {
  background: #fff !important;
  border: 1px solid #18316e !important;
  color: #18316e !important;
}

.styles_btnSalvar__zHwvF {
  background: #18316e !important;
  border: 1px solid #18316e !important;
  color: #fff !important;
}

/* Sem isso, o !important acima faz o botão parecer clicável mesmo desabilitado
   (MUI aplica Mui-disabled no mesmo elemento, mas não sobrescreve os estilos acima). */
.styles_btnSalvar__zHwvF.Mui-disabled {
  background: #9aa5c2 !important;
  border: 1px solid #9aa5c2 !important;
  color: #eef0f5 !important;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Apuracoes/styles.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,wBAAwB;EACxB,iCAAiC;EACjC,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,yCAAyC;AACzC;EACE,wBAAwB;EACxB,iCAAiC;EACjC,+BAA+B;EAC/B,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,mBAAmB;EACnB,6DAA6D;EAC7D,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,kCAAkC;EAClC,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,oBAAoB;EACpB,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,wBAAwB;EACxB,yCAAyC;EACzC,sBAAsB;EACtB,+BAA+B;EAC/B,gCAAgC;EAChC,iCAAiC;EACjC,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;uFACuF;AACvF;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,yBAAyB;EACzB,mBAAmB;AACrB","sourcesContent":[".title {\n  align-items: center;\n  display: flex;\n  justify-content: flex-start;\n}\n\n.content {\n  align-items: center !important;\n  display: flex !important;\n  flex-direction: column !important;\n  gap: 0.75rem !important;\n  padding-top: 1rem !important;\n}\n\n.periodRow {\n  display: flex;\n  gap: 0.75rem;\n  width: 100%;\n}\n\n.periodField {\n  flex: 1;\n}\n\n.contasResultadoField {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n  flex: 0 0 auto;\n  gap: 0.1rem;\n}\n\n.contasResultadoLabel {\n  font-size: 0.75rem;\n  color: rgba(0, 0, 0, 0.6);\n  white-space: nowrap;\n}\n\n.field {\n  width: 100%;\n}\n\n.readonlyBlock {\n  width: 100%;\n}\n\n.readonlyLabel {\n  color: rgba(0, 0, 0, 0.6);\n  display: block;\n  font-size: 0.75rem;\n  margin-bottom: 0.25rem;\n}\n\n.readonlyValue {\n  font-size: 0.875rem;\n}\n\n/* Modal Reprocessar — layout semântico */\n.reprocessarContent {\n  display: flex !important;\n  flex-direction: column !important;\n  align-items: stretch !important;\n  gap: 1.25rem !important;\n  padding-top: 0.5rem !important;\n}\n\n.reprocessarContexto {\n  margin: 0;\n  padding: 1rem 1.125rem;\n  border-radius: 10px;\n  background: linear-gradient(180deg, #f7f9fc 0%, #f0f3f9 100%);\n  border: 1px solid #e0e6f0;\n}\n\n.reprocessarContextoHeader {\n  margin: 0 0 0.875rem;\n  padding-bottom: 0.75rem;\n  border-bottom: 1px solid #e0e6f0;\n}\n\n.reprocessarEmpresa {\n  margin: 0 0 0.2rem;\n  font-size: 1rem;\n  font-weight: 600;\n  color: #1b3a5f;\n  line-height: 1.35;\n}\n\n.reprocessarCnpj {\n  margin: 0;\n  font-size: 0.8125rem;\n  font-variant-numeric: tabular-nums;\n  color: rgba(27, 58, 95, 0.72);\n  letter-spacing: 0.01em;\n}\n\n.reprocessarMeta {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 0.75rem 1.25rem;\n  margin: 0;\n}\n\n.reprocessarMetaItem {\n  min-width: 0;\n}\n\n.reprocessarMetaItem dt {\n  margin: 0 0 0.2rem;\n  font-size: 0.6875rem;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: rgba(0, 0, 0, 0.45);\n}\n\n.reprocessarMetaItem dd {\n  margin: 0;\n  font-size: 0.875rem;\n  color: rgba(0, 0, 0, 0.87);\n  word-break: break-word;\n}\n\n.reprocessarSecao {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.reprocessarSecaoTitulo {\n  margin: 0;\n  font-size: 0.8125rem;\n  font-weight: 600;\n  color: #1b3a5f;\n  letter-spacing: 0.01em;\n}\n\n.reprocessarFieldset {\n  margin: 0;\n  padding: 0;\n  border: none;\n  min-width: 0;\n}\n\n.reprocessarAnosGrid {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.15rem 0.25rem;\n}\n\n.reprocessarAnoItem {\n  margin: 0 !important;\n  min-width: 5.5rem;\n}\n\n.reprocessarVazio {\n  margin: 0;\n  font-size: 0.875rem;\n  color: rgba(0, 0, 0, 0.55);\n}\n\n.reprocessarSwitch {\n  margin: 0 !important;\n  align-self: flex-start;\n}\n\n.srOnly {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n.containerBtn {\n  display: flex !important;\n  justify-content: space-between !important;\n  width: 100% !important;\n  padding-left: 1.5rem !important;\n  padding-right: 1.5rem !important;\n  padding-bottom: 1.5rem !important;\n  margin: 0 !important;\n}\n\n.btnCancelar {\n  background: #fff !important;\n  border: 1px solid #18316e !important;\n  color: #18316e !important;\n}\n\n.btnSalvar {\n  background: #18316e !important;\n  border: 1px solid #18316e !important;\n  color: #fff !important;\n}\n\n/* Sem isso, o !important acima faz o botão parecer clicável mesmo desabilitado\n   (MUI aplica Mui-disabled no mesmo elemento, mas não sobrescreve os estilos acima). */\n.btnSalvar:global(.Mui-disabled) {\n  background: #9aa5c2 !important;\n  border: 1px solid #9aa5c2 !important;\n  color: #eef0f5 !important;\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `styles_title__-dKHt`,
	"content": `styles_content__J3auL`,
	"periodRow": `styles_periodRow__Xy5mk`,
	"periodField": `styles_periodField__KM7lu`,
	"contasResultadoField": `styles_contasResultadoField__Q2WGW`,
	"contasResultadoLabel": `styles_contasResultadoLabel__HAc0M`,
	"field": `styles_field__lBgUq`,
	"readonlyBlock": `styles_readonlyBlock__-004d`,
	"readonlyLabel": `styles_readonlyLabel__sH4Xe`,
	"readonlyValue": `styles_readonlyValue__vV+aM`,
	"reprocessarContent": `styles_reprocessarContent__A348D`,
	"reprocessarContexto": `styles_reprocessarContexto__fv9lg`,
	"reprocessarContextoHeader": `styles_reprocessarContextoHeader__hKuR9`,
	"reprocessarEmpresa": `styles_reprocessarEmpresa__1Q2qi`,
	"reprocessarCnpj": `styles_reprocessarCnpj__gCqQp`,
	"reprocessarMeta": `styles_reprocessarMeta__TobeC`,
	"reprocessarMetaItem": `styles_reprocessarMetaItem__NCWsv`,
	"reprocessarSecao": `styles_reprocessarSecao__d9b7o`,
	"reprocessarSecaoTitulo": `styles_reprocessarSecaoTitulo__coskN`,
	"reprocessarFieldset": `styles_reprocessarFieldset__TuAPp`,
	"reprocessarAnosGrid": `styles_reprocessarAnosGrid__4kBjr`,
	"reprocessarAnoItem": `styles_reprocessarAnoItem__v1fXV`,
	"reprocessarVazio": `styles_reprocessarVazio__iXBWB`,
	"reprocessarSwitch": `styles_reprocessarSwitch__dikVO`,
	"srOnly": `styles_srOnly__3ZNgQ`,
	"containerBtn": `styles_containerBtn__DNbY0`,
	"btnCancelar": `styles_btnCancelar__HU2XB`,
	"btnSalvar": `styles_btnSalvar__zHwvF`
};
export default ___CSS_LOADER_EXPORT___;
